import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31578f75"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal modal--success" }
const _hoisted_2 = { class: "modal__body" }
const _hoisted_3 = { class: "modal__content" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "text-muted" }

import Icon from '@/components/_shared/Icon/Icon.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'SuccessModal',
  emits: ['onClose'],
  setup(__props, { emit: __emit }) {

const emits = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: "modal__overlay",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('onClose')))
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: require(`@/assets/img/send-success.png`)
        }, null, 8, _hoisted_4),
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('modals.thankYou')), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('modals.sentSuccessfully')), 1),
        _createElementVNode("button", {
          class: "icon",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('onClose')))
        }, [
          _createVNode(Icon, { icon: "close" })
        ])
      ])
    ])
  ]))
}
}

})